import { EafDataEntryPage } from "./DataEntryPage";
import {
  EAFDataEntryProvider,
  useDataEntryContext,
} from "./context/reducer.provider";
import { TimerProvider } from "./context/timer.provider";
import { themeMESF } from "@dexteel/mesf-core";
import { ThemeProvider } from "@mui/material/styles";

type Props = {};

const EAFDataEntry = (props: Props) => {
  return (
    <EAFDataEntryProvider>
      <TimerProviderWrapper />
    </EAFDataEntryProvider>
  );
};

const TimerProviderWrapper = () => {
  const { state } = useDataEntryContext();
  return (
    <TimerProvider isOldProcess={!!state.deProcess?.process.IsOldProcess}>
      <div id={"dummy"} style={{ height: "0", width: "0" }}></div>
      <ThemeProvider theme={themeMESF}>
        <EafDataEntryPage />
      </ThemeProvider>
    </TimerProvider>
  );
};

export default EAFDataEntry;
